export class UserSearchParamDTO
{
    SearchText        :string;
    PermsetIDs        :string;
    AccountStatusIDs  :string;
    LockedStatusIDs   :string;
    ActivityStatusIDs :string;
    DepartmentIDs     :string;
}